import { Link } from "react-router-dom";
import { ArrowUpRight, ScanLine } from "lucide-react";
import { Reveal, Overline } from "../components/Reveal";
import { SERVICES } from "../data/content";
import Seo from "../components/Seo";

export default function ServicesIndex() {
  return (
    <div className="pt-28 pb-24 min-h-screen noise">
      <Seo title="Court Resurfacing Services Sydney | Speedy Resurfacing"
           description="12 specialist services — basketball, tennis, netball, school and commercial court resurfacing, custom design, line marking, repainting and repairs across Sydney & NSW."
           path="/services" />
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <Reveal>
          <Overline>Specialist Court Services</Overline>
          <h1 className="mt-5 font-heading font-black text-5xl md:text-7xl tracking-tighter">EVERYTHING COURTS.</h1>
          <p className="mt-5 max-w-xl text-zinc-400">From full resurfacing to precision line marking — a dedicated service for every court and every surface.</p>
        </Reveal>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s, i) => (
            <Reveal key={s.slug} delay={(i % 3) * 0.05}>
              <Link to={`/services/${s.slug}`} data-testid={`service-card-${s.slug}`}
                className="group flex h-full flex-col rounded-lg border border-white/10 bg-obsidian-800 p-7 hover:border-neon/40 transition-colors">
                <div className="flex items-start justify-between">
                  <span className="font-mono text-xs text-zinc-600">{String(i + 1).padStart(2, "0")}</span>
                  <ArrowUpRight className="text-zinc-700 group-hover:text-neon transition-colors" size={20} />
                </div>
                <h3 className="mt-6 font-heading font-bold text-xl group-hover:text-neon transition-colors">{s.title}</h3>
                <p className="mt-2 text-sm text-zinc-400 flex-1">{s.intro}</p>
                <span className="mt-4 font-mono text-[11px] uppercase tracking-widest text-neon">{s.short}</span>
              </Link>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="mt-16 flex flex-wrap gap-4">
            <Link to="/court-scan" className="inline-flex items-center gap-2 rounded-sm bg-neon px-7 py-4 font-bold text-obsidian shadow-neon"><ScanLine size={18} /> Scan My Court</Link>
            <Link to="/quote" className="rounded-sm border border-white/20 px-7 py-4 font-bold hover:border-neon hover:text-neon transition-colors">Request a Quote</Link>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
